import { Country, State } from 'country-state-city';

// Type definitions to match the existing interface
export interface CountryData {
  code: string;
  name: string;
  states?: StateData[];
}

export interface StateData {
  code: string;
  name: string;
}

// Get all countries
export const getAllCountries = (): CountryData[] => {
  return Country.getAllCountries().map(country => ({
    code: country.isoCode,
    name: country.name,
  }));
};

// Get states of a specific country by its ISO code
export const getStatesOfCountry = (countryCode: string): StateData[] => {
  return State.getStatesOfCountry(countryCode).map(state => ({
    code: state.isoCode,
    name: state.name,
  }));
};

// Get country by code
export const getCountryByCode = (countryCode: string): CountryData | undefined => {
  const country = Country.getCountryByCode(countryCode);
  if (!country) return undefined;
  
  return {
    code: country.isoCode,
    name: country.name,
  };
};

// Get state by country and state code
export const getStateByCode = (countryCode: string, stateCode: string): StateData | undefined => {
  const state = State.getStateByCodeAndCountry(stateCode, countryCode);
  if (!state) return undefined;
  
  return {
    code: state.isoCode,
    name: state.name,
  };
};

// For backwards compatibility, export countries as a function
// This maintains compatibility with existing code that imports { countries }
export const countries = getAllCountries();

// Backwards compatibility function for getStatesByCountry
export const getStatesByCountry = (countryCode: string): StateData[] => {
  return getStatesOfCountry(countryCode);
};